import React from "react";
import { View, Text, ScrollView, Dimensions } from "react-native";
import { BarChart } from "react-native-chart-kit";

const screenWidth = Dimensions.get("window").width; // Ancho de la pantalla

interface Props {
  weeklyHours: number[];
}

const TimeChart: React.FC<Props> = ({ weeklyHours = [] }) => {
  const chartWidth = screenWidth ; // 🔹 Ajustamos el ancho total del gráfico
  
  const data = {
    labels: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
    datasets: [{ data: weeklyHours.length === 7 ? weeklyHours : [5, 6, 7, 4, 8, 3, 5] }], 
  };

  return (
    <View className="bg-gray-800 p-4 rounded-2xl mb-4">
      <Text className="text-white text-lg font-semibold mb-2">Horas Trabajadas (Semana)</Text>
      <ScrollView horizontal showsHorizontalScrollIndicator={false} >
        <BarChart
        style={{ paddingLeft: 0, marginLeft: -35}}
          data={data}
          width={chartWidth} // 🔹 Ajuste para que entren todos los días
          height={200} // 🔹 Compactamos la altura
          yAxisLabel="" // 🔹 Eliminamos el doble "h"
          yAxisSuffix="h" // 🔹 Sólo "h" a la derecha del número
          fromZero={true} // 🔹 Asegura que inicie desde 0
          chartConfig={{
            backgroundColor: "#1f2937",
            backgroundGradientFrom: "#1f2937",
            backgroundGradientTo: "#1f2937",
            decimalPlaces: 0,
            barPercentage: 0.5, // 🔹 Reduce el espacio entre barras sin solaparlas
            fillShadowGradient: "rgba(75, 192, 192, 1)", // 🔹 Cambia el color de las barras
            fillShadowGradientOpacity: 1,
            color: (opacity = 1) => `rgba(75, 192, 192, ${opacity})`,
            labelColor: (opacity = 1) => `rgba(255, 255, 255, ${opacity})`,
            propsForLabels: { fontSize: 12 }, 
          }}
          verticalLabelRotation={0} // 🔹 No rotar los labels de los días
          
        />
      </ScrollView>
    </View>
  );
};

export default TimeChart;